import { useRegisterAgentContext } from '@backrs_ui/grow-ui/src/agentContext/useRegisterAgentContext';
import { appStrings } from '@backrs_ui/grow-ui/src/assets/appStrings';

const LIFE_READINESS_STRINGS = appStrings.modules.lifeReadiness;
const LEVEL_STRINGS = LIFE_READINESS_STRINGS.questionTooltips.consolidated;

export const useAgentContext = () => {
  useRegisterAgentContext({
    kind: 'visual',
    label: 'Score Explanation Table',
    display:
      'Card showing what each readiness level means, with four rows each containing a level name and description',
    data: {
      title: LIFE_READINESS_STRINGS.keyTitle,
      description: LIFE_READINESS_STRINGS.keyDescription,
      levels: LEVEL_STRINGS,
    },
  });
};
